import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TransactionService } from '../../service/transaction.service';
import { SpinnerService } from '../../service/spinner.service';
import {  finalize, Subscription } from 'rxjs';
import { StatusTransaction } from '@/enum/statusTransaction';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-transactiondetails',
  templateUrl: './transactiondetails.page.html',
  styleUrls: ['./transactiondetails.page.scss']
})
export class TransactiondetailsPage implements OnInit, OnDestroy {

  dataForm: FormGroup;
  private transaction_id: string;
  private unsubscribe: Subscription[] = [];
  public StatusTransaction: typeof StatusTransaction = StatusTransaction;

  constructor(private formBuilder: FormBuilder, private router: ActivatedRoute,  private transactionService: TransactionService,
     private spinnerService: SpinnerService, private translateService: TranslateService) { }

  ngOnInit() {
    this.transaction_id = this.router.snapshot.paramMap.get('id')
    this.dataForm = this.formBuilder.group({
      amount: [''],
      bank_id: [''],
      barcode: [''],
      creation_date: [''],
      status: [''],
      transaction_id: [''],
      user_id: [''],
      bank_checksum: [''],
      bank_end2end_id: [''],
      cart_id: [''],
      client_checksum: [''],
      client_reference: [''],
      comments: [''],
      created_by_id: [''],
      id: [''],
      last_modified: [''],
      last_update_by_id: [''],
      messages: [''],
      on_behalf_of_id: [''],
      pos_id: [''],
      trx_id: [''],
      user_account_bic: [''],
      user_account_iban: [''],
      user_email: [''],
      user_first_name: [''],
      user_last_name: [''],
      customer :[''],
      expiration_date: [''],
      pos: ['']
    });

    if(this.transaction_id) {
      this.unsubscribe.push(
        this.transactionService.getById(this.transaction_id).pipe(finalize(() => {
          this.spinnerService.hide();
        })).subscribe(val => {
            this.dataForm.patchValue({
              amount: val.amount,
              bank_id: val.bank_id,
              barcode: val.barcode,
              creation_date: new Date(val.creation_date).toLocaleDateString() + " " + new Date(val.creation_date).toLocaleTimeString(),
              status: this.translateService.instant(this.StatusTransaction[val.status]),
              transaction_id: val.transaction_id,
              user_id: val.user_id,
              bank_checksum: val.bank_checksum,
              bank_end2end_id: val.bank_end2end_id,
              cart_id: val.cart_id,
              client_checksum: val.client_checksum,
              client_reference: val.client_reference,
              created_by_id: val.created_by_id,
              id: val.id,
              last_modified: new Date(val.last_modified).toLocaleDateString() + " " + new Date(val.last_modified).toLocaleTimeString(),
              pos: val.pos,
              trx_id: val.trx_id,
              user_account_bic: val.user_account_bic,
              user_account_iban: val.user_account_iban,
              user_email: val.user_email,
              user_first_name: val.user_first_name,
              user_last_name: val.user_last_name,
              customer: val.customer,
              expiration_date: new Date(val.expiration_date).toLocaleDateString() + " " + new Date(val.expiration_date).toLocaleTimeString()
            });
          }
        ));
    }

  }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }
}
